export default "__VITE_ASSET__Ca764ES3__"